import {Animation} from 'animation';
import {createButton} from "./common/ui";
import screen from '../cfg/screen-config.js'

export default class SettingsGameMode extends PIXI.Container
{
    constructor() {

        super();

        let self = this;

        const isPC = screen.isPC;
        const path = screen.path;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");
        this.sndSelectClick = sounds.get("res/sounds/settings_click");

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[path+"/utility_background.png"]);
        this.background.position.set(isPC ? 334 : -12, isPC ? 127 : 13);
        this.background.interactive = true;     // block interactive of overlaid buttons
        this.addChild(this.background);

        this.ind = 0;
        this.indNew = 0;

        let arrButtonsInfo = [
            {x: isPC ? 69 : 57, y: isPC ? 153 : 138, folder: "s_mode_fix"},
            {x: isPC ? 661 : 57, y: isPC ? 153 : 377, folder: "s_mode_x2"}
        ];
        this.buttonsRadio = [];
        for (let i = 0; i < arrButtonsInfo.length; ++i) {
            let info = arrButtonsInfo[i];
            let button = createButton(this.background, info.x, info.y, info.folder);
            button.texUp    = PIXI.utils.TextureCache[info.folder + "/up.png"];
            button.texDown  = PIXI.utils.TextureCache[info.folder + "/down.png"];

            // .off(event, fn) clear all listeners or concrete
            button.off('pointerdown'); button.off('pointerup'); button.off('pointerover');
            button.off('pointerupoutside'); button.off('pointerout');

            button.texOver  = PIXI.utils.TextureCache[info.folder + "/over.png"];
            button.texOld   = PIXI.utils.TextureCache[info.folder + "/up.png"];
            button.on('pointerover',function() {
                button.texOld = button.texture;
                button.texture = button.texOver;
            });

            button.on('pointerout',function() {
                if (button.texture === button.texOver)
                    button.texture = button.texOld;
            });

            button.on('pointerup',function() {
                self.indNew = i;
                self._setActiveButton(button);
                self.sndSelectClick.play()
            });
            this.buttonsRadio.push(button);
        }
        this._setActiveButton(this.buttonsRadio[0]);

        this.buttonOk = createButton(this.background, isPC ? 492 : 195, isPC ? 650 : 610, "ok_settings", this.sndBtnClick);
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.background = null;
        this.buttonOk = null;

        for (let obj of this.buttonsRadio) obj = null;
        this.buttonsRadio = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
        this.sndSelectClick.stop();
        this.sndSelectClick = null;
    }

    close () {
        this._setActiveButton(this.buttonsRadio[this.ind])
    }

    setOnButtonApplyEvent (func) {
        let self = this;
        this.buttonOk.callback = function() {self.ind = self.indNew; func(self.ind);};
    }

    _setActiveButton(button) {
        for (let radioButton of this.buttonsRadio) {
            radioButton.texture = radioButton.texUp;
        }
        button.texture = button.texDown;
    }
}



// WEBPACK FOOTER //
// ./src/settings_game_mode.es6